import { render } from "./DuplicateCampaignAction.vue?vue&type=template&id=b757080a"
import script from "./DuplicateCampaignAction.vue?vue&type=script&lang=ts"
export * from "./DuplicateCampaignAction.vue?vue&type=script&lang=ts"
script.render = render

export default script